export function Footer() {
    return (
        <footer className="mt-24 border-t border-gray-700/50 bg-[#2A2D35]/95" role="contentinfo">
            <div className="mx-auto max-w-7xl px-4 py-12 sm:px-6 lg:px-8">
                <div className="mb-8 grid gap-8 sm:grid-cols-2 md:grid-cols-3">
                    <div>
                        <div className="mb-4 flex items-center gap-3">
                            <img src="/assets/logo.png" alt="Turkish Airlines Logo" className="h-8 w-auto" />
                        </div>
                        <p className="text-sm leading-relaxed text-[#CBD5E1]">Model Context Protocol Server providing AI assistants with access to Turkish Airlines services.</p>
                    </div>

                    <div>
                        <h3 className="mb-4 font-semibold text-[#F8FAFC]">Quick Links</h3>
                        <nav aria-label="Footer navigation">
                            <ul className="space-y-2 text-sm text-[#CBD5E1]">
                                <li>
                                    <a href="https://claude.ai/settings/integrations" target="_blank" rel="noopener noreferrer" className="transition-colors hover:text-[#E81932]">
                                        Connect via Claude.ai
                                    </a>
                                </li>
                                <li>
                                    <a href="https://www.turkishairlines.com" target="_blank" rel="noopener noreferrer" className="transition-colors hover:text-[#E81932]">
                                        Turkish Airlines
                                    </a>
                                </li>
                                <li>
                                    <a href="https://www.turkishairlines.com/en-tr/legal-notice/privacy-policy/" target="_blank" rel="noopener noreferrer" className="transition-colors hover:text-[#E81932]">
                                        Privacy Policy
                                    </a>
                                </li>
                            </ul>
                        </nav>
                    </div>

                    <div>
                        <h3 className="mb-4 font-semibold text-[#F8FAFC]">Support</h3>
                        <div className="space-y-3">
                            <div className="flex items-start gap-2 text-sm text-[#CBD5E1]">
                                <svg className="mt-0.5 h-4 w-4 flex-shrink-0" fill="none" stroke="currentColor" viewBox="0 0 24 24" aria-hidden="true">
                                    <path strokeLinecap="round" strokeLinejoin="round" strokeWidth="2" d="M3 8l7.89 5.26a2 2 0 002.22 0L21 8M5 19h14a2 2 0 002-2V7a2 2 0 00-2-2H5a2 2 0 00-2 2v10a2 2 0 002 2z"></path>
                                </svg>
                                <a href="mailto:digitallab@thy.com" className="transition-colors hover:text-[#E81932]">
                                    digitallab@thy.com
                                </a>
                            </div>
                            <div className="flex items-center gap-2 text-sm" role="status" aria-live="polite">
                                <div className="h-2 w-2 animate-pulse rounded-full bg-[#22C55E]" aria-hidden="true"></div>
                                <span className="text-[#CBD5E1]">
                                    Server: <span className="font-semibold text-[#22C55E]">Active</span>
                                </span>
                            </div>
                        </div>
                    </div>
                </div>

                <div className="border-t border-gray-700/50 pt-8">
                    <div className="flex flex-col items-center justify-between gap-4 text-sm text-[#CBD5E1] md:flex-row">
                        <p>&copy; 2026 Turkish Airlines. All rights reserved.</p>
                        <div className="flex items-center gap-6">
                            <span>Built with Model Context Protocol</span>
                        </div>
                    </div>
                </div>
            </div>
        </footer>
    );
}
